import React from 'react';
import {Alert} from '@bonprix/design-system';

export default function CartGlobalAvailabilityMessage({items, texts, undeliverableItemCount}) {
    const allItemsNotDeliverable = undeliverableItemCount === determineTotalItemCount(items);

    return (
        <div className="flex flex-col justify-between w-full mt-2.5">
            <Alert isOpen severity="warning" showCloseIcon={false}>
                {undeliverableItemCount > 1
                    ? undeliverableItemCount + texts.cot09_articles_not_deliverable
                    : texts.cot09_article_not_deliverable
                }
            </Alert>
            {allItemsNotDeliverable && (
                <div className="mt-2.5">
                    <Alert isOpen severity="error" showCloseIcon={false}>
                        {texts.mobile_cot09_warenkorb_nicht_bereit_global_error}
                    </Alert>
                </div>
            )
            }
        </div>
    );
}

function determineTotalItemCount(items) {
    return items.reduce((accumulator, item) => {
        return accumulator + item.quantity;
    }, 0);
}
